import { render, staticRenderFns } from "./refundRecord.vue?vue&type=template&id=6698667a&scoped=true&"
import script from "./refundRecord.vue?vue&type=script&lang=js&"
export * from "./refundRecord.vue?vue&type=script&lang=js&"
import style0 from "./refundRecord.vue?vue&type=style&index=0&id=6698667a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6698667a",
  null
  
)

export default component.exports